import React from 'react';
import { vsClose, vsChevronLeft } from '@deephaven/icons';
import "./Page.css";
import Button from "../Button.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A page view with a back button in the bottom left, a title at the top, and a close button in the top right.
 * Back and close buttons will only appear if `onBack` and/or `onClose` callbacks are set.
 */
export function Page(_ref) {
  var children = _ref.children,
    onBack = _ref.onBack,
    onClose = _ref.onClose,
    title = _ref.title,
    dataTestId = _ref['data-testid'];
  return /*#__PURE__*/_jsxs("div", {
    className: "navigation-page",
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "navigation-title-bar",
      children: [/*#__PURE__*/_jsx("div", {
        className: "navigation-left-buttons",
        children: onBack !== undefined && /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: "btn-back m-1 btn-sm",
          "data-testid": "btn-page-back",
          onClick: onBack,
          icon: vsChevronLeft,
          children: "Back"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "navigation-title",
        children: title
      }), /*#__PURE__*/_jsx("div", {
        className: "navigation-right-buttons",
        children: onClose !== undefined && /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: "btn-close btn-sm px-2 m-1",
          "data-testid": "btn-page-close",
          onClick: onClose,
          icon: vsClose,
          tooltip: "Close"
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "navigation-content",
      children: children
    })]
  });
}
export default Page;
//# sourceMappingURL=Page.js.map